import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Categories from './pages/Categories';
import ProductDetail from './pages/ProductDetail';
import About from './pages/About';
import Sources from './pages/Sources';
import Stores from './pages/Stores';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="categories" element={<Categories />} />
        <Route path="categories/:id" element={<Categories />} />
        <Route path="products/:id" element={<ProductDetail />} />
        <Route path="stores" element={<Stores />} />
        <Route path="about" element={<About />} />
        <Route path="sources" element={<Sources />} />
      </Route>
    </Routes>
  );
}
